<template>
  <v-card
    class="mx-auto"
  >
    <v-card-text>
      <v-data-table dense v-if="!loading"
        :headers="tableHeader"
        :items="tableData"
        item-key="id"
        :items-per-page="pagination"
        :search="search"
        :custom-filter="filter"
        @click:row="clickDisambiguator"
      >
        <template v-slot:top>
        <div v-if="!hideToolbar">
        <v-row class="mx-auto ml-6">
          <v-col 
            style="max-width: 385px;">
          <v-datetime-picker 
            label="Από (Ημερομηνία)" 
            v-model="fromDateFilter" 
            :timePickerProps="timeOpts"
            dateFormat="dd-MM-yyyy" 
            timeFormat="HH:mm"
            pick12HourFormat="false"> 
            <template slot="dateIcon">
              <v-icon>mdi-calendar</v-icon>
            </template>
            <template slot="timeIcon">
              <v-icon>mdi-clock</v-icon>
            </template>
          </v-datetime-picker>
          </v-col>

          <v-col
            style="max-width: 385px;" class="mx-auto ml-2">
          <v-datetime-picker 
            label="Έως (Ημερομηνία)" 
            v-model="toDateFilter" 
            :timePickerProps="timeOpts"
            dateFormat="dd-MM-yyyy" 
            timeFormat="HH:mm"> 
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
          </v-datetime-picker>
          </v-col>
        </v-row>

        <v-row justify-space-between class="mb-6">
        <!-- <v-text-field
          outline 
          max=30
          v-model="search"
          label="Αναζήτηση"
          class="ml-12"
        ></v-text-field> -->

        <!-- <v-text-field
          outline 
          max=30
          v-model="eventIdFilter"
          label="Χαρακτηριστικό Συμβάντος"
          class="ml-8"
        ></v-text-field> -->

        <!-- <v-text-field
          outline 
          max=30
          v-model="sensorIdFilter"
          label="Χαρακτηριστικό Αισθητήρα"
          class="ml-8"
        ></v-text-field> -->

        <!-- <v-text-field
          outline 
          max=30
          v-model="sensorIndexFilter"
          label="Δείκτης Αισθητήρα"
          class="ml-8"
        ></v-text-field> -->

        <!-- <v-text-field
          outline 
          max=30
          v-model="campFilter"
          label="Περιοχή Ευθύνης"
          class="ml-8 mr-8"
        ></v-text-field> -->

        <CampPicker
          :camps="campFilter"
          :clearCampSelTrigger="clearCampSelTrigger"
          ref="campPicker"/>

        </v-row>

        <v-row class="mb-4">
          <v-btn
            color="blue"
            class="text-left ml-12"
            @click="load">
            ΑΝΑΖΗΤΗΣΗ
          </v-btn>

          <v-btn
            class="text-left ml-4"
            @click="resetFilters">
            ΚΑΘΑΡΙΣΜΟΣ ΦΙΛΤΡΩΝ
          </v-btn>

          <v-btn
            color="green"
            class="text-left ml-4"
            @click="downloadEvents">
            ΚΑΤΕΒΑΣΜΑ
          </v-btn>

          <v-dialog
            v-model="alarmSquelchDialog"
            v-if="isAdmin"
            width="500"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="orange"
                dark
                v-bind="attrs"
                v-on="on"
                class="text-left ml-4"
                :disabled="(selEvent === null) ? true : (selEvent.id === null || selEvent.id === undefined || selEvent.id.length === 0 || !selEvent.sensorIndex < 0 || !selEvent.sensorIndex >= 5 || selEvent.sensorIndex >= 3 || !selEvent.activity)"
              >
                Σιγαση {{ (selEvent === null) ? "Συναγερμου" : selEvent.id.substring(0,6)+"..." }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                Επιβεβαίωση
              </v-card-title>

              <v-card-text>
                Η σίγαση ενός συναγερμού είναι μη-αναστρέψιμη (προσθέτει χειροκίνητα συμβάν απενεργοποίησης).
                Πληκτρολογήστε {{ randConfirmation }} για να επιβεβαιώσετε την σίγαση του συναγερμού {{ (selEvent === null) ? "" : selEvent.id }}:

                  <v-text-field
                    style="max-width: 200px;"
                    outline 
                    v-model="randConfirmInput"
                    :label="randConfirmation"
                  ></v-text-field>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="orange"
                  @click="squelchAlarm"
                  :disabled="randConfirmInput !== randConfirmation"
                >
                  Ναι, σιγαση
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-btn
            v-if="isAdmin"
            color="red"
            class="text-left ml-4"
            @click="wipePastEvents">
            ΕΚΚΑΘΑΡΙΣΗ 4 ΜΗΝΩΝ
          </v-btn>

        </v-row>
      </div>
      </template>

      </v-data-table>

    </v-card-text>

  </v-card>
</template>

<script>
import CampPicker from '@/components/CampPicker.vue'

export default {
  name: 'EventManagement',
  props: {
    sensorIdFilter: {
      type: String,
      default: "",
      required: false
    },
    hideToolbar: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  components: {
    CampPicker
  },
  async mounted() {
    const u = this.$store.state.user

    if (!(u.camps && u.camps.length > 0)) {
      return
    }

    if (!(u.isAdmin || u.isCampMaster)) {
      this.campFilter = [u.camps[0]]
      this.$refs.campPicker.selectedCamps = this.campFilter
    }

    this.isAdmin = u.isAdmin

    await this.load()
  },
  data: () => {
    return {
      search: '',
      loading: false,
      campFilter: [],
      eventIdFilter: "",
      fromDateFilter: "",
      toDateFilter: "",
      sensorIndexFilter: "",
      error: "",
      sensorEvents: [],
      pagination: 15,
      clicks: 0,
      clickDelay: 200,
      selEvent: null,
      randConfirmInput: "",
      randConfLen: 4,
      dialog: false,
      alarmSquelchDialog: false,
      isAdmin: false,
      displayNames: {
        //'id': 'Αναγνωριστικό Συμβάντος',
        'sensordescription': 'Περιγραφή',
        //'sensorid': 'Αναγνωριστικό Αισθητήρα',
        'sensorindex': 'Τύπος Συμβάντος',
        'activity': 'Κατάσταση',
        'camp': 'Περιοχή Ευθύνης',
        'timestamp': 'Χρονοσφραγίδα',
        'confirmations': 'Επικυρώσεις'
      },
      clearCampSelTrigger: 0
    }
  },
  computed: {
    timeOpts:() => {
      return {
          format: "24hr"
      }
    },
    randConfirmation() {
      let pool = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
      let ret = ""
      for (var i=0; i<this.randConfLen; i++) {
        ret += pool.charAt(Math.floor(Math.random() * pool.length))
      }
      return ret
    },
    tableHeader() {
      const self = this
      if (!this.sensorEvents || this.sensorEvents.length == 0) {
        return []
      }

      return Object.keys(this.sensorEvents[0])
            .filter(x => Object.keys(self.displayNames).includes(x.toLowerCase()))
            .map(function(x){ 
              return {
                text: self.displayNames[x.toLowerCase()],
                align: 'start',
                sortable: true,
                value: x
              }
            }
          )
    },
    tableData() {
      return this.sensorEvents.map(function(x) {
        var c = Object.assign({}, x)

        c.activity = x.activity ? 'ON' : 'OFF'
        var dt = new Date(x.timestamp)
        
        dt.setTime(dt.getTime() - (new Date().getTimezoneOffset() * 60 * 1000))
        c.timestamp = dt.toLocaleString('el-GR')
        c.confirmations = x.confirmations == null || x.confirmations.length == 0 ? 'Καμία' : x.confirmations.length

        const orientationMap = {
          0: "Νότια",
          1: "Βορειοδυτικά",
          2: "Βορειοανατολικά",
          3: "Χαμηλή Μπαταρία",
          4: "Check",
          5: "Συναγερμος"
        }

        c.sensorIndex = orientationMap[c.sensorIndex]

        return c
      })
    }
  },
  methods: {
    findSensorEventById(eventId) {
      var stuff = this.sensorEvents.filter(element => {
        if (element.id == eventId) {
          return element
        }
      });
      if (stuff.length > 1) {
        console.log(`[EventManagement :: findSensorEventById] Found ${stuff.length} events with the same ID: ${eventId}`)
        return null
      } else if (stuff.length == 0) {
        console.log(`[EventManagement :: findSensorEventById] Could not find event with ID: ${eventId}`)
        return null
      }
      return stuff[0];
    },
    goEventDetails(value) {
      this.$router.push(`/events/${value.id}`)
    },
    clickDisambiguator: function(event){
      this.clicks++
      if(this.clicks === 1) {
        var self = this
        this.timer = setTimeout(function() {
          self.selEvent = self.findSensorEventById(event.id)
          self.clicks = 0
        }, this.clickDelay)
      } else {
          clearTimeout(this.timer);
          this.goEventDetails(event)
          this.clicks = 0
      }
    },
    async resetFilters() {
      this.search = ""
      this.campFilter = []
      this.eventIdFilter = ""
      this.sensorIdFilter = ""
      this.sensorIndexFilter = ""
      this.pagination = 15
      this.clearCampSelTrigger = (this.clearCampSelTrigger+1)%2
      await this.load()
    },
    async squelchAlarm() {
      try{
        const query = { eventId: this.selEvent.id}
        const response = await this.$axios.delete('/sensorEvents/clearEvent', { params:{...query}})
        console.log(`Squelching alarm: ${this.selEvent.id}`)
        console.log(response)
        this.selEvent = null
        this.randConfirmInput = ""
      } catch (e) {
        console.log(e.response)
        this.error = e.response.data
      }
      this.alarmSquelchDialog = false
    },
    async wipePastEvents() {
      try{
        let num_months = 4
        var query = {lookBack: `${num_months*30}:00:00`}
        //query.lookBack.setMonth(4)
        const response = await this.$axios.delete('/sensorEvents/eventWipe', { params: {...query}})
        console.log(`Wiping past events`)
        console.log(query.lookBack)
        console.log(response)
      } catch (e) {
        console.log(e.response)
        this.error = e.response.data
      }
    },
    async downloadEvents () {
      var q = {}

      if (this.fromDateFilter !== "" && this.fromDateFilter != null) {
        q.fromDate = this.fromDateFilter.toISOString()
      }

      if (this.toDateFilter !== "" && this.toDateFilter != null) {
        q.toDate = this.toDateFilter.toISOString()
      }

      try{
        const response = await this.$axios.get('/sensorEvents/export', {params: {...q} })
        const csvContent = "data:text/csv;charset=utf-8," + response.data

        var encodedUri = encodeURI(csvContent)

        var link = document.createElement("a")
        link.hidden = true
        link.setAttribute("href", encodedUri)
        link.setAttribute("download", "data.csv")
        document.body.appendChild(link);
        link.click()

      } catch (e) {
        console.log(e.response)
        this.error = e.response.data 
      }
    },
    async load() {
      this.loading = true
      this.selEvent = null
      this.randConfirmInput = ""

      var q = {
        pageSize: -1  // get everything, pagination is handled here anyway
      }

      if (this.fromDateFilter !== "" && this.fromDateFilter != null) {
        q.fromDate = this.fromDateFilter.toISOString()
      }

      if (this.toDateFilter !== "" && this.toDateFilter != null) {
        q.toDate = this.toDateFilter.toISOString()
      }

      if (this.sensorIndexFilter.trim() !== "" && !isNaN(parseInt(this.sensorIndexFilter))) {
        q.sensorIndex = parseInt(this.sensorIndexFilter)
      }

      if (this.sensorIdFilter.trim() !== "") {
        q.sensorId = this.sensorIdFilter
      }

      if (this.eventIdFilter.trim() !== "") {
        q.eventIdFilter = this.eventIdFilter
      }

      this.sensorEvents = []
      const ref_campPicker = this.$refs.campPicker
      for (var selCamp of ref_campPicker.selectedCamps) {
        try{
          q.camp = selCamp
          const response = await this.$axios.get('/sensorEvents', { params: {...q} })
          this.sensorEvents = this.sensorEvents.concat(response.data)
        } catch (e) {
          console.log(e.response)
          this.error = e.response.data 
        }
      }

      this.loading = false
    },
    /* eslint-disable */
    filter (value, search, _item) {  // _item unused var
    /* eslint-enable */
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLowerCase().indexOf(search) !== -1
    }
  }
}
</script>
